<template>
  <div>
    <b-row
      v-if="activatedField === 'dato_felt'"
      class="px-1"
    >
      <b-col md="12">
        <b-form-group
          label="Select number of days after letter generation"
          label-for="email_template"
        >
          <b-form-input
            :id="`${data}-${type}-dato_felt`"
            v-model="fieldObject.functional_value"
            type="number"
            @change="removeFieldError(fieldObject.functional_value, `${data}-${type}-dato_felt`)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'module_run_date'"
      class="px-1"
    >
      <b-col md="12">
        <b-form-group
          label="Select Module"
          :label-for="`${data}-${type}-module_run_date`"
        >
          <v-select
            v-model="fieldObject.functional_value"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="prevModuleOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-module_run_date`"
            @input="removeSelectError(fieldObject.functional_value, `${data}-${type}-module_run_date`)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'debtia.currencyConverter'"
      class="px-1"
    >
      <b-col md="12">
        <b-form-group
          label="Select The Statement"
          :label-for="`${data}-${type}-statement_id`"
        >
          <v-select
            v-model="fieldObject.statement_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statementsOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-statement_id`"
            @input="removeSelectError(fieldObject.statement_id, `${data}-${type}-statement_id`)"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          label="Convert to Currency"
          :label-for="`${data}-${type}-currency_id`"
        >
          <v-select
            v-model="fieldObject.currency_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="convertCurrenciesOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-currency_id`"
            @input="removeSelectError(fieldObject.currency_id, `${data}-${type}-currency_id`)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'interest_rate_percentage'"
      class="px-1"
    >
      <b-col md="12">
        <b-form-group
          label="Select Base Document Type"
          :label-for="`${data}-${type}-base_types`"
        >
          <v-select
            v-model="fieldObject.base_types"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="baseDocumentTypes"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            :input-id="`${data}-${type}-base_types`"
            @input="removeSelectError(fieldObject.base_types.length > 0 ? 'applicable' : '' , `${data}-${type}-base_types`)"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          label="To Fetch"
          :label-for="`${data}-${type}-document_order`"
        >
          <v-select
            v-model="fieldObject.document_order"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="fetchingDocumentsOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-document_order`"
            @input="removeSelectError(fieldObject.document_order, `${data}-${type}-document_order`)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'debtia.paymentLink'"
      class="px-2"
    >
      <div
        class="amount-period-base-divs w-100"
      >
        <b-col
          class="optionsClass"
          md="12"
        >
          <b-form-checkbox
            :id="'amount_based_plan-'+data+'-'+type"
            class="custom-control-primary"
            @change="updateInstallmentPlanFields($event, data+'-'+type, 'amount_based_plan', fieldObject)"
          >
            {{ $t('DEBTIA_AMOUNT_BASE_PLAN') }}
          </b-form-checkbox>
        </b-col>
        <b-col
          :id="'col-min_amount-'+data+'-'+type"
          style="display: none"
          md="12"
        >
          <b-form-group
            :label="$t('DEBTIA_MIN_AMOUNT')"
            :label-for="'min_amount-'+data+'-'+type"
          >
            <b-form-input
              :id="'min_amount-'+data+'-'+type"
              type="number"
              placeholder="Min. Amount"
              :input-id="'min_amount-'+data+'-'+type"
              @input="updateInstallmentPlanFields($event, data+'-'+type, 'min_amount', fieldObject), removeErrorBorder('min_amount-'+data+'-'+type, 0)"
            />
            <small
              v-if="minAmountError"
              class="text-danger dd"
            >The min amount must be at least 100</small>
          </b-form-group>
        </b-col>
      </div>
      <div
        class="amount-period-base-divs w-100"
      >
        <b-col
          class="optionsClass"
          md="12"
        >
          <b-form-checkbox
            :id="'period_based_plan-'+data+'-'+type"
            class="custom-control-primary"
            @change="updateInstallmentPlanFields($event, data+'-'+type, 'period_based_plan', fieldObject)"
          >
            {{ $t('DEBTIA_PERIOD_BASE_PLAN') }}
          </b-form-checkbox>
        </b-col>
        <b-col
          :id="'col-max_months-'+data+'-'+type"
          style="display: none"
          md="12"
        >
          <b-form-group
            :label="$t('DEBTIA_MAX_MONTH')"
            :label-for="'max_months-'+data+'-'+type"
          >
            <b-form-input
              :id="'max_months-'+data+'-'+type"
              type="number"
              placeholder="Max. Month"
              :input-id="'max_months-'+data+'-'+type"
              @input="updateInstallmentPlanFields($event, data+'-'+type, 'max_months', fieldObject), removeErrorBorder('max_months-'+data+'-'+type, 0)"
            />
            <small
              v-if="maxMonthsError"
              class="text-danger dd"
            >The max months must be at least 1.</small>
          </b-form-group>
        </b-col>
      </div>
      <b-col
        :id="'col-interest_free_months-'+data+'-'+type"
        style="display: none"
        md="12"
      >
        <b-form-group
          :label="$t('DEBTIA_INTEREST_FREE_MONTHS')"
          :label-for="'interest_free_months-'+data+'-'+type"
        >
          <b-form-input
            :id="'interest_free_months-'+data+'-'+type"
            type="number"
            placeholder="Interest Free Months"
            :input-id="'interest_free_months-'+data+'-'+type"
            @change="updateInstallmentPlanFields($event, data+'-'+type, 'interest_free_months', fieldObject), removeErrorBorder('interest_free_months-'+data+'-'+type, 0)"
          />
          <small
            v-if="interestFreeMonthsError"
            class="text-danger"
          >{{ $t('DEBTIA_INTEREST_FREE_POSITIVE') }}</small>
        </b-form-group>
      </b-col>
      <b-col
        :id="'col-payment_date-'+data+'-'+type"
        style="display: none"
        md="12"
      >
        <b-form-group
          :label="$t('DEBTIA_INSTALLMENT_START_DATE')"
          :label-for="'payment_date-'+data+'-'+type"
        >
          <v-select
            :id="'payment_date-'+data+'-'+type"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="paymentDateOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="'payment_date-'+data+'-'+type"
            @input="updateInstallmentPlanFields($event, data+'-'+type, 'payment_date', fieldObject), removeErrorBorder('payment_date-'+data+'-'+type, 1)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'letter_sent_date' || activatedField === 'debtia.case_presentation'"
      class="px-1"
    >
      <b-col
        v-if="activatedField === 'debtia.case_presentation'"
        :id="`${data}-${type}-case-presentation-statements`"
        md="12"
      >
        <b-form-group
          label="Collection Fee Statement"
          :label-for="`${data}-${type}-case-presentation`"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statements"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-case-presentation`"
            @input="removeSelectError($event, `${data}-${type}-case-presentation`, 'case_presentation')"
          />
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          label="Select Letter Template"
          :label-for="`${data}-${type}-send_letters`"
        >
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="letterTemplates"
            :reduce="val => val.value"
            :clearable="false"
            multiple
            :input-id="`${data}-${type}-send_letters`"
            @input="removeSelectError($event, `${data}-${type}-send_letters`, true)"
          />
        </b-form-group>
      </b-col>
      <b-col
        v-if="activatedField === 'letter_sent_date'"
        md="12"
      >
        <b-form-group
          label="To Fetch"
          :label-for="`${data}-${type}-order`"
        >
          <v-select
            v-model="fieldObject.order"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="fetchingLettersOptions"
            :reduce="val => val.value"
            :clearable="false"
            :input-id="`${data}-${type}-order`"
            @input="removeSelectError(fieldObject.order, `${data}-${type}-order`)"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="activatedField === 'debtia.freeText'"
      class="px-1"
    >
      <b-col md="12">
        <b-form-group
          label="Free Text Note"
          :label-for="`${data}-${type}-freeTextField`"
        >
          <b-form-input
            :id="`${data}-${type}-freeTextField`"
            v-model="fieldObject.free_text_note"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
// import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    // BFormInput,
    BFormCheckbox,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
    activatedField: {
      validator(value) {
        return typeof value === 'string' || typeof value === 'number'
      },
      required: true,
    },
    convertCurrenciesOptions: {
      type: Array,
      required: true,
    },
    prevModuleOptions: {
      type: Array,
      required: true,
    },
    statementsOptions: {
      type: Array,
      required: true,
    },
    fieldObject: {
      type: Object,
      required: true,
    },
    letterTemplates: {
      type: Array,
      required: true,
    },
    statements: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      minAmountError: false,
      maxMonthsError: false,
      interestFreeMonthsError: false,
      paymentDateOptions: [
        { label: 'Now', value: 'now' },
        { label: 'First day next month', value: 'first_day_next_month' },
      ],
      fetchingDocumentsOptions: [
        { label: 'First Base Document', value: 'first' },
        { label: 'Last Base Document', value: 'last' },
      ],
      baseDocumentTypes: [
        { label: 'Invoice (Faktura)', value: 1 },
        { label: 'Court Verdict (Dom) ', value: 2 },
        { label: 'Promissory note (Gældsbrev)', value: 3 },
        { label: 'Undefined/Other (Andet)', value: 4 },
      ],
      receipient: '',
      fetchingLettersOptions: [
        { label: 'First Letter', value: 'asc' },
        { label: 'Last Letter', value: 'desc' },
      ],
    }
  },
  watch: {
    'fieldObject.statement_id': {
      handler() {
        if (this.activatedField === 'debtia.currencyConverter' && this.fieldObject.statement_id) {
          const statementObject = this.statementsOptions.filter(e => e.value === this.fieldObject.statement_id)
          this.fieldObject.statement_type = statementObject[0].type
        }
      },
    },
  },
  created() {
    // this.getReasons()
  },
  methods: {
    removeErrorBorder(id, select) {
      if (select) {
        const dropdown = document.getElementById(`${id}`)
        const selector = dropdown.querySelector('.vs__dropdown-toggle')
        selector.classList.remove('inputErrorClassField')
      } else {
        const selector = document.getElementById(id)
        selector.classList.remove('inputErrorClassField')
      }
    },
    updateInstallmentPlanFields(data, id, key, obj) {
      // This condition is used to check if the user has inputted a value in the min_amount field
      // that is less than 100. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'min_amount') {
        if (parseInt(data, 10) < 100) {
          this.minAmountError = true
        } else {
          this.minAmountError = false
        }
      }
      // This condition is used to check if the user has inputted a value in the max_months field
      // that is less than 1. If the condition is true, we show an error message and prevent the
      // user from saving the page.
      if (key === 'max_months') {
        if (parseInt(data, 10) < 1) {
          this.maxMonthsError = true
        } else {
          this.maxMonthsError = false
        }
      }
      // This condition is used to check if the user has inputted a value in the interest_free_months field
      // that is less than 1 or greater than 3. If the condition is true, we show an error message and
      // prevent the user from saving the page.
      if (key === 'interest_free_months') {
        if (parseInt(data, 10) < 0) {
          this.interestFreeMonthsError = true
        } else {
          this.interestFreeMonthsError = false
        }
      }

      // eslint-disable-next-line no-param-reassign
      obj[key] = data

      if (key === 'amount_based_plan') {
        const minAmountElement = document.getElementById(`col-min_amount-${id}`)
        minAmountElement.style.display = obj[key] ? 'block' : 'none'
      }

      if (key === 'period_based_plan') {
        const maxMonthsElement = document.getElementById(`col-max_months-${id}`)
        maxMonthsElement.style.display = obj[key] ? 'block' : 'none'
      }

      if (key === 'amount_based_plan' || key === 'period_based_plan') {
        const interestFreeMonthsElement = document.getElementById(`col-interest_free_months-${id}`)
        interestFreeMonthsElement.style.display = (obj.amount_based_plan || obj.period_based_plan) ? 'block' : 'none'
        const paymentDateElement = document.getElementById(`col-payment_date-${id}`)
        paymentDateElement.style.display = (obj.amount_based_plan || obj.period_based_plan) ? 'block' : 'none'
      }
    },
    removeFieldError(data, id) {
      if (data) {
        this.$el.querySelector(`#${id}`).classList.remove('inputErrorClassField')
      }
    },
    removeSelectError(data, id, letterVar = false) {
      if (data) {
        const selector = document.getElementById(id)
        const ancestorWithClass = selector.closest('.vs__dropdown-toggle')
        ancestorWithClass.classList.remove('inputErrorClassField')
      }
      if (letterVar) {
        if (letterVar === 'case_presentation') {
          this.fieldObject.functional_value = data
        } else {
          const filteredData = this.letterTemplates.filter(item => data.includes(item.value)).map(item => ({ id: item.value, title: item.label }))
          this.fieldObject.letters = filteredData
        }
      }
    },
  },
// mounted() {
//   this.showModal()
// },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

</style>
